/* TechStyle PLP — list/grid view toggle */
(function () {
  const STORAGE_KEY = 'ts-plp-view';
  const GRID_CLASS = 'ts-view--grid';
  const LIST_CLASS = 'ts-view--list';

  function init() {
    const toggle = document.getElementById('ts-view-toggle');
    const grid = document.getElementById('product-grid');
    if (!toggle || !grid) return;

    const saved = sessionStorage.getItem(STORAGE_KEY) || 'grid';
    applyView(saved, grid, toggle);

    toggle.addEventListener('click', function () {
      const current = grid.classList.contains(LIST_CLASS) ? 'list' : 'grid';
      const next = current === 'grid' ? 'list' : 'grid';
      sessionStorage.setItem(STORAGE_KEY, next);
      applyView(next, grid, toggle);
    });
  }

  function applyView(view, grid, toggle) {
    if (view === 'list') {
      grid.classList.add(LIST_CLASS);
      grid.classList.remove(GRID_CLASS);
      toggle.setAttribute('aria-label', 'Switch to grid view');
      toggle.setAttribute('data-view', 'list');
    } else {
      grid.classList.add(GRID_CLASS);
      grid.classList.remove(LIST_CLASS);
      toggle.setAttribute('aria-label', 'Switch to list view');
      toggle.setAttribute('data-view', 'grid');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
